import axios from "axios";
import moment from "moment";
import { errorHandler } from "./libs/lib.js";

const baseurl = "fileazure";
export default {
  list(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const keys = [
          "page",
          "limit",
          "sortBy",
          "sortDir",
          "filename",
          "type",
          "pjxkey",
        ];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/${baseurl}${str}`;
        const { data } = await axios.get(url);
        const { meta, list } = data;
        obj.total = meta.total;
        resolve(list);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  synchronizefromserver(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/${baseurl}/synchronize-from-server`;
        await axios.post(url, obj);
        resolve(true);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  reprocess(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/${baseurl}/reprocess`;
        await axios.post(url, obj);
        resolve(true);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  exportxls(obj = {}) {
    return new Promise((resolve, reject) => {
      try {
        const keys = ["page", "limit", "sortBy", "sortDir", "tgl1", "tgl2"];
        let str = "";
        for (const key in obj) {
          if (keys.indexOf(key) >= 0 && obj[key]) {
            str += str ? "&" : "?";
            str += key + "=" + encodeURIComponent(obj[key]);
          }
        }
        const url = `/${baseurl}/export-report-xls/${str}`;
        axios({
          url: url,
          method: "GET",
          responseType: "blob", // important
        }).then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute(
            "download",
            `repayment_${moment().format("YYYYMMDDHHmm")}.xlsx`
          );
          document.body.appendChild(link);
          link.click();
          // window.location.assign(url);
          resolve(link);
        });
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },

  remove(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        const url = `/${baseurl}/${obj.container}/${obj.filename}`;
        const { data } = await axios.delete(url, obj);
        resolve(data);
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  download(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        if (obj.storage_location != "aws_s3") {
          throw new Error("Tidak bisa didownload..");

          // const url = `/${baseurl}/download/${obj.container}/${obj.filename}`;
          // axios({
          //     url: url,
          //     method: 'GET',
          //     responseType: 'blob', // important
          // }).then((response) => {
          //     const url = window.URL.createObjectURL(new Blob([response.data]));
          //     const link = document.createElement('a');
          //     link.href = url;
          //     link.setAttribute('download', `${obj.filename}`);
          //     document.body.appendChild(link);
          //     link.click();
          //     resolve(link);
          // })
          // .catch(error=>{
          //     errorHandler(error, reject)
          // })
        } else {
           
          const url = `/awss3file/download/${obj.tableKey}`;
          axios({
            url: url,
            method: "GET",
            responseType: "blob", // important
          })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${obj.filename}`);
              document.body.appendChild(link);
              link.click();
              resolve(link);
            })
            .catch((error) => {
              errorHandler(error, reject);
            });
        }
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
  downloadFormated(obj) {
    return new Promise(async (resolve, reject) => {
      try {
        if (obj.storage_location != "aws_s3") {
          throw new Error("Tidak bisa didownload..");

          // const url = `/${baseurl}/download/${obj.container}/${obj.filename}`;
          // axios({
          //     url: url,
          //     method: 'GET',
          //     responseType: 'blob', // important
          // }).then((response) => {
          //     const url = window.URL.createObjectURL(new Blob([response.data]));
          //     const link = document.createElement('a');
          //     link.href = url;
          //     link.setAttribute('download', `${obj.filename}`);
          //     document.body.appendChild(link);
          //     link.click();
          //     resolve(link);
          // })
          // .catch(error=>{
          //     errorHandler(error, reject)
          // })
        } else {
           
          const url = `/awss3file/download-formated/${obj.tableKey}`;
          axios({
            url: url,
            method: "GET",
            responseType: "blob",
          })
            .then((response) => {
              const url = window.URL.createObjectURL(new Blob([response.data]));
              const link = document.createElement("a");
              link.href = url;
              link.setAttribute("download", `${obj.filename}`);
              document.body.appendChild(link);
              link.click();
              resolve(link);
            })
            .catch((error) => {
              errorHandler(error, reject);
            });
        }
      } catch (error) {
        errorHandler(error, reject);
      }
    });
  },
};
